import { render } from "./AuthorizationRenderer.vue?vue&type=template&id=247ca354&scoped=true"
import script from "./AuthorizationRenderer.vue?vue&type=script&lang=js"
export * from "./AuthorizationRenderer.vue?vue&type=script&lang=js"

import "./AuthorizationRenderer.vue?vue&type=style&index=0&id=247ca354&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247ca354"]])

export default __exports__